import { useCallback } from 'react';
import { Admin__FeatureManagementCategory, Admin__FeatureManagementScope, useGetFeatureManagementLazyQuery as _useGetFeatureManagementLazyQuery, useSetFeatureManagementValueMutation as _useSetFeatureManagementValueMutation, useUpdateFeatureManagementAssignmentMutation as _useUpdateFeatureManagementAssignmentMutation, } from '../generated/graphql-types';
export { Admin__FeatureManagementCategory, Admin__FeatureManagementScope };
export const useGetFeatureManagementLazyQuery = () => {
    const [getFeatureManagement, { data, loading, error },] = _useGetFeatureManagementLazyQuery({
        fetchPolicy: 'no-cache',
    });
    const stableGetFeatureManagement = useCallback((orgIdentifier, category, scope = Admin__FeatureManagementScope.Cluster) => getFeatureManagement({
        variables: {
            org_identifier: orgIdentifier,
            category,
            scope,
        },
    }), [getFeatureManagement]);
    return {
        error,
        loading,
        data: data?.Admin_getFeatureManagement?.Data,
        getFeatureManagement: stableGetFeatureManagement,
    };
};
export const useUpdateFeatureManagementAssignmentMutation = () => {
    const [_updateAssignment, { data, loading, error },] = _useUpdateFeatureManagementAssignmentMutation();
    return {
        error,
        loading,
        data: data?.Admin_updateFeatureManagementAssignment?.Data,
        updateFeatureManagementAssignment: (variables, onSuccess, onError) => _updateAssignment({
            variables,
            onCompleted: responseData => {
                if (responseData?.Admin_updateFeatureManagementAssignment
                    ?.Error) {
                    onError?.(new Error(responseData.Admin_updateFeatureManagementAssignment.Error));
                    return;
                }
                onSuccess?.();
            },
            onError: err => {
                onError?.(err);
            },
        }),
    };
};
export const useSetFeatureManagementValueMutation = () => {
    const [_setValue, { data, loading, error },] = _useSetFeatureManagementValueMutation();
    return {
        error,
        loading,
        data: data?.Admin_setFeatureManagementValue?.Data,
        setFeatureManagementValue: (variables, onSuccess, onError) => _setValue({
            variables: variables,
            onCompleted: responseData => {
                if (responseData?.Admin_setFeatureManagementValue?.Error) {
                    onError?.(new Error(responseData.Admin_setFeatureManagementValue.Error));
                    return;
                }
                onSuccess?.();
            },
            onError: err => {
                onError?.(err);
            },
        }),
    };
};
//# sourceMappingURL=feature-management-service.js.map